import styled from "styled-components";

export const UserNoticeBlockContainer = styled.section<{
  backgroundColor: string;
}>`
  background: ${({ backgroundColor }) => backgroundColor};
  border-radius: 8px;
  box-shadow: 0px 0px 20px ${({ theme }) => theme.colors.transparent.white10};
  display: flex;
  align-items: center;
`;

export const UserNoticeBlockImage = styled.figure`
  margin: 0;
  padding: 0;
  width: 110px;
  height: 90px;
  position: relative;
  overflow: hidden;
  align-self: flex-end;
`;

export const UserNoticeBlockDesc = styled.div`
  margin: 0;
  padding: 16px 20px;
  flex-grow: 1;
`;

export const UserNoticeDetails = styled.p<{ color: string }>`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ color }) => color};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  margin: 0;
  font-weight: bold;
`;

export const UserNoticeMessage = styled.p<{ color: string }>`
  font-family: ${({ theme }) => theme.fonts.primary};
  color: ${({ color }) => color};
  font-size: ${({ theme }) => theme.fontSizes["lg"]};
  font-weight: bold;
  margin: 8px 0 0 0;
`;

export const UserNoticeEmptySlotTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["3xl"]};
  font-weight: bold;
  font-family: ${({ theme }) => theme.fonts.primary};
  text-align: center;
`;

export const UserNoticeEmptySlotSubTitle = styled.div`
  font-size: ${({ theme }) => theme.fontSizes["md"]};
  font-family: ${({ theme }) => theme.fonts.secondary};
  text-align: center;
`;

export const UserNoticeEmptyContainer = styled.div`
  display: flex;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  margin-top: 20px;
`;
